import React from 'react';

const BlogCardSkeleton: React.FC = () => {
  return (
    <div className="rounded-2xl bg-white shadow-lg overflow-hidden animate-pulse">
      <div className="h-48 bg-gray-200" />
      <div className="p-6">
        <div className="h-4 w-24 bg-gray-200 rounded mb-3" />
        <div className="h-6 w-full bg-gray-200 rounded mb-2" />
        <div className="h-6 w-3/4 bg-gray-200 rounded mb-4" />
        <div className="h-4 w-full bg-gray-200 rounded mb-2" />
        <div className="h-4 w-2/3 bg-gray-200 rounded mb-4" />
        <div className="h-4 w-20 bg-gray-200 rounded" />
      </div>
    </div>
  );
};

export default BlogCardSkeleton;
